import { IonButton, IonButtons, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonLabel, IonRow, IonTitle, IonToolbar } from '@ionic/react';
import { arrowBackOutline, syncOutline } from 'ionicons/icons';
import React from 'react';

type Props = {
    totalCashBack: number;
    resgateCashBack?: number;
    items: any[];
    closeAction: Function;
    closeActionSimple: Function;
}

const Cashback: React.FC<Props> = (props: Props) => {

    function formatarData(isoDate: string): string {
        if (!isoDate) return "";
        const date = new Date(isoDate);
        return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
    }

    function corDoStatus(status: string): string {
        switch (status) {
            case 'disponivel': return 'var(--ion-color-success)';
            case 'pendente': return 'var(--ion-color-warning)';
            case 'resgatado': return 'var(--ion-color-medium)';
            case 'expirado': return 'var(--ion-color-danger)';
            case 'cancelado': return 'var(--ion-color-danger)';
            default: return 'var(--ion-color-medium)';
        }
    }

    function labelDoStatus(status: string): string {
        switch (status) {
            case 'disponivel': return 'DISPONÍVEL';
            case 'pendente': return 'PENDENTE';
            case 'resgatado': return 'RESGATADO';
            case 'expirado': return 'EXPIRADO';
            case 'cancelado': return 'CANCELADO';
            default: return status?.toUpperCase();
        }
    }

    return (
        <>
            <IonHeader className="ion-no-border">
                <IonToolbar className="pedido-fluxo-modal-toolbar">
                    <IonButtons slot="start" className="pedido-fluxo-back-buttons">
                        <IonButton aria-label="Voltar" className="pedido-fluxo-back-button" fill="clear" onClick={() => props.closeActionSimple()}>
                            <IonIcon icon={arrowBackOutline} />
                        </IonButton>
                    </IonButtons>
                    <IonTitle className="ion-text-wrap"><span className="modal-title-text">Meu Cashback</span></IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent>
                <div style={{ padding: '20px', textAlign: 'center', background: 'var(--ion-color-light)', marginBottom: '10px' }}>
                    <IonLabel color="medium" style={{ fontSize: '14px', textTransform: 'uppercase', letterSpacing: '1px' }}>Saldo Disponível</IonLabel>
                    <h1 style={{ fontSize: '32px', fontWeight: '800', margin: '5px 0', color: 'var(--ion-color-success)' }}>
                        R$ {props.totalCashBack.toLocaleString('pt-br', { minimumFractionDigits: 2 })}
                    </h1>
                </div>

                <div style={{ padding: '0 10px' }}>
                    <IonLabel style={{ paddingLeft: '10px', fontWeight: 'bold' }}>Extrato Detalhado</IonLabel>

                    {props.items.length === 0 ? (
                        <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                            <IonIcon icon={syncOutline} style={{ fontSize: '48px', color: '#ccc' }} />
                            <p style={{ color: '#999' }}>Você ainda não possui cashback disponível nesta loja.</p>
                        </div>
                    ) : (
                        <IonGrid>
                            {props.items.map((item, index) => (
                                <IonRow
                                    key={index}
                                    style={{
                                        borderBottom: '1px solid #f0f0f0',
                                        padding: '14px 0',
                                        alignItems: 'center'
                                    }}
                                >
                                    <IonCol size="8">
                                        <div style={{ fontSize: '14px', fontWeight: 'bold' }}>
                                            Compra de R$ {item.valorPedido?.toLocaleString('pt-br', { minimumFractionDigits: 2 })}
                                        </div>

                                        <div
                                            style={{
                                                fontSize: '11px',
                                                color: corDoStatus(item.status),
                                                fontWeight: 'bold',
                                                marginTop: '2px'
                                            }}
                                        >
                                            {item.status === 'disponivel'
                                                ? `Expira em ${formatarData(item.dataExpiracao)}`
                                                : labelDoStatus(item.status)}
                                        </div>
                                    </IonCol>

                                    <IonCol size="4" style={{ textAlign: 'right' }}>
                                        <div
                                            style={{
                                                color: corDoStatus(item.status),
                                                fontWeight: 800,
                                                fontSize: '16px'
                                            }}
                                        >
                                            {item.status === 'disponivel' ? '+' : ''}
                                            R$ {item.valorCashback?.toLocaleString('pt-br', { minimumFractionDigits: 2 })}
                                        </div>

                                        <div style={{ fontSize: '10px', color: '#999' }}>
                                            {item.percentualAplicado}% cashback
                                        </div>
                                    </IonCol>
                                </IonRow>
                            ))}
                        </IonGrid>
                    )}
                </div>
            </IonContent>

            <IonFooter className="ion-no-border">
                <IonToolbar style={{ padding: '10px' }}>
                    {(props.resgateCashBack && props.resgateCashBack > 0) ? (
                        <IonButton
                            expand="block"
                            onClick={() => props.closeAction(0)}
                            style={{ height: '50px', fontWeight: 'bold' }}
                        >
                            Remover Cashback
                        </IonButton>
                    ) : (
                        <IonButton
                            expand="block"
                            disabled={props.totalCashBack <= 0}
                            onClick={() => props.closeAction(props.totalCashBack)}
                            style={{ height: '50px', fontWeight: 'bold' }}
                        >
                            Utilizar Cashback
                        </IonButton>
                    )}
                </IonToolbar>
            </IonFooter>
        </>
    );
};

export default Cashback;
